import { Controller } from '@hotwired/stimulus'

// Keeps the hidden flower[unit] field in sync with the unit <select> and the
// free-text custom input, so exactly one unit value is submitted. The custom
// input is revealed only when "Custom…" is chosen.
export default class extends Controller {
  static targets = ['select', 'customInput', 'value']

  connect() {
    this.sync()
  }

  selectChanged() {
    this.sync()
  }

  customChanged() {
    this.sync()
  }

  sync() {
    this.customInputTarget.classList.toggle('hidden', !this.isCustom)
    this.valueTarget.value = this.isCustom
      ? this.customInputTarget.value
      : this.selectTarget.value
  }

  get isCustom() {
    return this.selectTarget.value === 'custom'
  }
}
